import React from "react";
import getDecryptedToken from "../../api/getDecryptedToken";
import Error403 from "../../views/error403/Error403";

export default function SuperAdminRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const role = getDecryptedToken("role");
  if (role !== "Super Admin") {
    return <Error403 />;
  }
  return <>{children}</>;
}
